import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { getStatusRequest, logoutRequest } from '../actions/authentication';
import Login from '../components/container/pages/Login';

const PrivateRoute = ({ component: Component, getStatusRequest, currentUser, ...rest }) => {
  useEffect(() => {
    getStatusRequest().then(
      () => {
        if(!rest.status.valid){
          // logout the session
          let loginData = {
              isLoggedIn: false,
              email: ''
          };

          document.cookie='key=' + btoa(JSON.stringify(loginData));
        }
        else {
          console.log('')
        }
      }
    )

  }, [Component])

    return(
    <Route
      {...rest}
      render={props => {
        if(!rest.status.valid) {
          return <Login {...props} />;
        }
        else {
          return <Component {...props} />;
        }
      }}
    />)
};

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser,
  status: state.AuthManager.status,
  loginstatus: state.AuthManager.login
});

const mapDispatchToProps = (dispatch) => {
  return {
      getStatusRequest: () => {
          return dispatch(getStatusRequest());
      },
      logoutRequest: () => {
          return dispatch(logoutRequest());
      }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
